export interface ICancelReason {
  Code: string;
  Name: string;
  IsActive: boolean;
}

export class CancelReason implements ICancelReason {
  Code: string;
  Name: string;
  IsActive: boolean;
}
